import { createFileRoute } from '@tanstack/react-router';
import { UnitsModule } from '@/modules/unit';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/unit')({
  component: UnitsModule,
});
